import React from 'react';
import Modal from '../ModalPage';
import '../ModalPage/ModalPage.scss';

export default function ConfirmModal({ open, title, message, onCancel, onConfirm }) {
    if (!open) return null;

    return (
        <Modal title={title}>
            <p>{message}</p>
            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                <button className="button-secondary" onClick={onCancel}>Cancel</button>
                <button className="button-primary" onClick={onConfirm}>Confirm</button>
            </div>
        </Modal>
    );
}